export default "__VITE_ASSET__DB1eg1La__"